import {
  AstroBreadcrumb,
  breadcrumbArray,
} from '@/components/ui/custom/AstroBreadcrumb';
import ErrorComponent from '@/components/ui/custom/ErrorComponent';
import HeadTitle from '@/components/ui/custom/HeadTitle';
import PageTitle from '@/components/ui/custom/PageTitle';
import Layout from '@/components/template/Layout';
import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { projectsQuerykeys } from '@/data/services/querykeys';
import { Project } from '@/models/Project';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import LoadingView from '../courses/LoadingView';
import ProjectViewContent from '../../components/projects/view/ProjectViewContent';

export default function ProjectView() {
  const { id: idParam } = useParams();
  const { state } = useLocation();
  const id = Number(idParam);

  const { queryFn: projectQueryFn, queryKey: projectQueryKey } =
    projectsQuerykeys.get(id);
  const {
    data: project,
    isInitialLoading: isLoading,
    isError,
  } = useQuery({
    enabled: !isNaN(id),
    queryFn: projectQueryFn,
    queryKey: projectQueryKey,
    staleTime: REQUEST_STALE_TIME_IN_MS,
    placeholderData: (state as Project) || undefined,
  });
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.view',
  });

  if (isLoading) {
    return (
      <Layout>
        <LoadingView />
      </Layout>
    );
  } else if (isError || !project) {
    return (
      <Layout>
        <ErrorComponent
          errorTextTitle={t('projectNotFound')}
          errorTextSubTitle={t('checkInfo')}
        />
      </Layout>
    );
  }

  const breadcrumbItems: breadcrumbArray[] = [
    {
      name: 'Home',
      routeType: 'home',
      url: '/',
    },
    { name: t('projects'), routeType: 'projects', url: '/projects' },
    {
      name: project.title,
      routeType: 'projects',
      url: '',
    },
  ];

  return (
    <Layout className="overflow-visible">
      <HeadTitle routeInfo={`${project.title} - ${t('projects')}`} />
      <header className="flex flex-col gap-3">
        <AstroBreadcrumb breadcrumbList={breadcrumbItems} />
        <PageTitle position="mb-2" headingText={project.title} backButton />
      </header>
      <ProjectViewContent project={project} />
    </Layout>
  );
}
